export class CannotFetchIntentError extends Error {
  constructor() {
    super('Cannot fetch payment intent. Id or nonce is missing.');
    this.name = 'CannotFetchIntentError';
  }
}
